import * as React from 'react'
import { cn } from '@/utilities/cn'

export interface RichTextSectionProps {
  heading?: string
  children: React.ReactNode
  variant?: 'card' | 'plain'
  className?: string
}

export const RichTextSection: React.FC<RichTextSectionProps> = ({
  heading,
  children,
  variant = 'card',
  className,
}) => {
  return (
    <section
      className={cn(
        variant === 'card'
          ? 'bg-white/80 backdrop-blur-sm rounded-2xl shadow-sm border border-slate-200 p-6'
          : '',
        className,
      )}
    >
      {heading ? (
        <h2 className="text-2xl font-kadwa font-semibold text-slate-800 mb-6">{heading}</h2>
      ) : null}
      <div className="prose prose-slate max-w-none">{children}</div>
    </section>
  )
}

export default RichTextSection
